import { Component } from '@angular/core';
import { ApiService } from './shared/services/api.service';
import { AuthGuard } from './shared/guards/auth.guard';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'tego-web';
  accessToken = localStorage.getItem("access_token");
  constructor(private apiService: ApiService,authService: AuthGuard,private router: Router) {
     this.apiService.getDepartments()
     .subscribe((res: any) => {
         if(res.status === 'Success') {       
           localStorage.setItem('departments',JSON.stringify(res.data));
         }
     });
  }
}
